/*
 * Public API Surface of ngx-print
 */
export { NgxPrintDirective } from './lib/ngx-print.directive';
export { NgxPrintModule } from './lib/ngx-print.module';
export { NgxPrintService } from './lib/ngx-print.service';
export { PrintOptions } from './lib/print-options';
